import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderProgressSitefinityIntegrations extends ResourceItemHtmlProvider {
    constructor(filterServices) {
        super(filterServices);
        this.typeTaxonParentId = 'ec96d930-b8d3-42ad-a9a6-4d0eb3197bfa';
        this.integrationTypeTaxonId = '56de7340-9890-41da-ac65-340f47084e0f';
    }

    getItemHtml(item) {
        let html = '';
        if (item && item.taxonomyNavigationProperty){
            let typeTaxon = item.taxonomyNavigationProperty
            .filter(taxon => taxon.ParentId == this.typeTaxonParentId)[0];
            let typeText = typeTaxon?.Title ?? "";

            html += `
            <div class="col-6 -xl-half -s-full -mb4">
                <div class="Elevated -full -pr -bg-white -br5 -oh">
                    <div class="IntegrationItem">
                        <div class="IntegrationItem-image">
                            <img src="${item.Image.Url}" alt="integration thumbnail"/>                            
                        </div>
                        <hr class="-mt1 -mb1 -accent-grey0 -op-4 -full">
                        <div class="IntegrationItem-info">
                            <span class="IntegrationItem-hint -ttu">${this.encodeHtml(typeText)}</span>
                            <a href="/sitefinity-cms/integration/${item.UrlName}" class="-accento-0 -mb1 -ps HoverBox HoverBox--over IntegrationItem-title h4">${this.encodeHtml(item.Title)}</a>
                            <div class="IntegrationItem-summary">${this.encodeHtml(item.Summary)}</div>
                            <a href="/sitefinity-cms/integration/${item.UrlName}"><span class="-i-arrow -fr -fs28"></span></a>
                        </div>
                    </div>
                </div>
            </div>`;
        }

        return html;
    }
}
